<div class="modal-header">
  <h4 class="modal-title pull-left">Assign Collector</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="title">
    We have detected that this order is not yet tied to an existing Bank. What action would you like to take?
  </div>

  <div class="actions">
    <button type="button" class="btn btn-rbv default" (click)="onIgnore()">Ignore</button>
    <button type="button" class="btn btn-rbv" (click)="assignToBank()">Assign to Bank</button>
    <button type="button" class="btn btn-rbv" (click)="createNewBank()">Create New Bank</button>
  </div>

  <!-- <div *ngIf="clients.length && clients.length > 0 && !isAssignToBank" class="users-list mb-3">
     <div class="users">
       <div class="item" *ngFor="let client of clients; let i = index;">
         <div class="row">
           <div class="column col-md-12 user-column" (click)="selectBank(client)">
             <div class="user-info">
               <div *ngIf="client?.COMPANY_NAME" class="user-email">
                {{client?.COMPANY_NAME}}
               </div>
             </div>
           </div>
         </div>
       </div>
     </div>
  </div> -->

  <div *ngIf="isAssignToBank"  class="assign">
      <label class="rbv-label">Bank Name</label>
      <input-search [provider]="clientProvider" placeholder="Select Bank" (valueChange)="clientSelected($event)"></input-search>
  </div>
</div>

<div class="modal-footer" *ngIf="selectedClient">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" (click)="assignClientToReport()">Accept</button>
</div>
